<template>
  <div>
    <el-select :value="state" value-key="key" :size="size" :placeholder="$t('table.state')" @input="change($event)" :clearable="true">
      <el-option label="----------" value="" />
      <el-option label="待使用" value="0" />
      <el-option label="使用中" value="1" />
      <el-option label="已停开" value="2" />
      <el-option label="已销户" value="3" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      state: 0
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.state = val
      this.$emit('input', this.state)
    }
  },
  mounted () {
    this.state = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.state = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/StateSelect.vue